import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LandingNav.css';

const LandingNav = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <header className="nav">
      <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        <img src="/logo-mark.png" alt="" className="logo-mark" aria-hidden="true" />
        <span className="logo-text">TRCKLE</span>
      </div>

      <nav>
        <a href="#features">Features</a>
        <a href="#pricing">Pricing</a>
        <a href="#creators">For Creators</a>
        <Link to="/login" className="btn login">
          Login
        </Link>
      </nav>
    </header>
  );
};

export default LandingNav;
